import { Box } from "@mui/material";

const ChevronRightIcon = ({
  height = 24,
  width = 24,
  color = "#657482",
  className = "",
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 0,
        ...sx,
      }}
    >
      <svg
        width={width}
        className={className}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 4.125L16 12.0624L8 19.9998"
          stroke={color}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export default ChevronRightIcon;
